import React from 'react';
import styled from '@emotion/styled';
interface IProps {
    onToogle?: (event: any) => void;
    isToggled?: boolean;
    disabled?: boolean;
}

const ToggleSwitchStyled = styled.label`
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    input[type='checkbox'] {
        display: none;
        &:checked + .switch {
            background-color: ${({ theme }) => theme.toggleButton.backgroundColorActive};
            &::before {
                transform: translateX(19px);
                background-color: ${({ theme }) => theme.colors.white[100]};
            }
        }
    }
    &.disabled {
        opacity: 0.3;
        cursor: default;
        margin-left: 0px;
    }
    .switch {
        position: absolute;
        cursor: pointer;
        background-color: #ccc;
        background-color: ${({ theme }) => theme.toggleButton.backgroundColor};
        border-radius: 25px;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transition: background-color 0.2s ease;
        &::before {
            position: absolute;
            content: '';
            left: 2px;
            top: 2px;
            width: 20px;
            height: 20px;
            background-color: ${({ theme }) => theme.colors.white[100]};
            border-radius: 50%;
            transition: transform 0.3s ease;
            box-shadow: 0 2px 6px rgba(0, 0, 0, .12);
        }
    }
`;

const ToggleSwitch = ({ onToogle, isToggled, disabled }: IProps) => {
    const handleToogleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isToggleOn = !!event.target.checked;
        onToogle(isToggleOn);
    };

    return (
        <ToggleSwitchStyled className={disabled ? 'disabled' : ''}>
            <input
                type="checkbox"
                checked={isToggled}
                onChange={handleToogleChange}
                disabled={!!disabled}
            />
            <span className="switch" />
        </ToggleSwitchStyled>
    );
};
export default ToggleSwitch;
